"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nProvider = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Language_1 = require("@opsbase/lib-i18n/Language");
const axios_1 = __importDefault(require("axios"));
const react_1 = __importDefault(require("react"));
const axiosLoader = function (language) {
    return __awaiter(this, void 0, void 0, function* () {
        if (this.alreadyLoaded(language))
            return;
        const i18nCode = (0, Language_1.languageCode)(language);
        const v = yield axios_1.default.get(`/assets/nls/${i18nCode}.json`);
        this.load(language, v.data);
    });
};
exports.I18nProvider = react_1.default.memo((props) => {
    const { nls, children, enableLoader = false } = props;
    if (enableLoader)
        lib_i18n_1.default.loader = axiosLoader;
    Object.keys(nls).forEach((key) => {
        lib_i18n_1.default.load(key, nls[key]);
    });
    return react_1.default.createElement(react_1.default.Fragment, null, children);
});
exports.default = exports.I18nProvider;
